<template>
  <div class="generate-modal">
    <el-form label-width="110px" class="generate-form">
      <!-- 稿件类型 -->
      <div class="form-section">
        <div class="section-title">
          <i class="el-icon-file-text"></i>
          <span>稿件类型</span>
        </div>
        <el-form-item label="选择类型" class="form-item">
          <div class="radio-group-wrapper">
            <label
                v-for="item in filteredDocTypeOptions"
                :key="item.value"
                class="radio-card"
                :class="{ active: documentType === item.value }"
                @click="documentType = item.value"
            >
              <div class="radio-icon">
                <i :class="item.icon"></i>
              </div>
              <div class="radio-content">
                <span class="radio-label">{{ item.label }}</span>
                <span class="radio-desc">{{ item.desc }}</span>
              </div>
              <el-radio
                  v-model="documentType"
                  :label="item.value"
                  class="radio-hidden"
                  @change="radioChange"
              />
            </label>
          </div>
        </el-form-item>
      </div>

      <!-- 文献解读专属区域 -->
      <div v-if="documentType === '02'" class="form-section">
        <div class="section-title">
          <i class="el-icon-book-open"></i>
          <span>文献设置</span>
        </div>

        <!-- 文献方向 -->
        <el-form-item label="文献方向" class="form-item">
          <el-select
              v-model="aiKeyword"
              placeholder="请选择解读方向"
              class="custom-select"
          >
            <el-option
                v-for="(item, index) in columns"
                :key="index"
                :label="item"
                :value="item"
            />
          </el-select>
        </el-form-item>

        <!-- 文献来源 -->
        <el-form-item label="文献来源" class="form-item">
          <div class="radio-group-wrapper">
            <label
                v-for="item in uploadTypeOptions"
                :key="item.value"
                class="radio-card small"
                :class="{ active: uploadType === item.value }"
                @click="uploadType = item.value"
            >
              <i :class="item.icon"></i>
              <span class="radio-label">{{ item.label }}</span>
              <el-radio
                  v-model="uploadType"
                  :label="item.value"
                  class="radio-hidden"
              />
            </label>
          </div>
        </el-form-item>

        <!-- 文献选择 -->
        <el-form-item label="文献文件" class="form-item">
          <div class="literature-selector" v-if="uploadType === '02'">
            <div class="selector-info" v-if="selectedLiteratureName">
              <i class="el-icon-file-text"></i>
              <span class="file-name">{{ selectedLiteratureName }}</span>
            </div>
            <el-button
                type="primary"
                icon="el-icon-search"
                @click="openLiteraturePopup"
                class="search-btn"
            >
              {{ selectedLiteratureName ? '重新选择' : '搜索文献' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 手动上传文献 -->
        <el-form-item label="上传文献" class="form-item" v-if="uploadType === '01'">
          <div class="upload-wrapper">
            <UploadOss
                v-model="uploadFileUrl"
                placeholder="点击或拖拽上传"
                accept=".pdf,.docx,.doc"
                upload-url="/article/oss/upload/literature?type=literature"
                target-server="http://localhost:8079"
                @file-change="onFileChange"
            />
          </div>
          <!-- 显示上传的文件名 -->
          <div v-if="uploadFileUrl" class="uploaded-file-info">
            <i class="el-icon-file-text"></i>
            <span>{{ uploadedFileName || '已上传文件' }}</span>
          </div>
        </el-form-item>
      </div>

      <!-- 科普征文专属区域 -->
      <div v-if="documentType === '01'" class="form-section">
        <div class="section-title">
          <i class="el-icon-lightbulb"></i>
          <span>内容设置</span>
        </div>

        <!-- 生成方式 -->
        <el-form-item label="生成方式" class="form-item">
          <div class="radio-group-wrapper">
            <label
                v-for="item in inputTypeOptions"
                :key="item.value"
                class="radio-card small"
                :class="{ active: inputType === item.value }"
                @click="inputType = item.value"
            >
              <i :class="item.icon"></i>
              <span class="radio-label">{{ item.label }}</span>
              <el-radio
                  v-model="inputType"
                  :label="item.value"
                  class="radio-hidden"
              />
            </label>
          </div>
        </el-form-item>

        <!-- 文章方向 选择模式 -->
        <el-form-item label="文章方向" class="form-item" v-if="inputType === '01'">
          <el-select
              v-model="aiKeyword"
              placeholder="请选择文章方向"
              class="custom-select"
          >
            <el-option
                v-for="item in keywordsList"
                :key="item.id"
                :label="item.keywordType"
                :value="item.keywordType"
            />
          </el-select>
        </el-form-item>

        <!-- 文章方向 手动输入 -->
        <el-form-item label="关键词" class="form-item" v-if="inputType === '02'">
          <el-input
              v-model="aiKeyword"
              placeholder="输入关键词，例如：肺癌预防、糖尿病管理"
              class="custom-input"
          >
            <template slot="append">
              <i class="el-icon-tags"></i>
            </template>
          </el-input>
        </el-form-item>
      </div>

      <!-- 案例解读专属区域 -->
      <div v-if="documentType === '03'" class="form-section">
        <div class="section-title">
          <i class="el-icon-user"></i>
          <span>病例设置</span>
        </div>

        <!-- 病例来源 -->
        <el-form-item label="病例来源" class="form-item">
          <div class="radio-group-wrapper">
            <label
                v-for="item in uploadTypeOptions"
                :key="item.value"
                class="radio-card small"
                :class="{ active: uploadType === item.value }"
                @click="uploadType = item.value"
            >
              <i :class="item.icon"></i>
              <span class="radio-label">{{ item.label }}</span>
              <el-radio
                  v-model="uploadType"
                  :label="item.value"
                  class="radio-hidden"
              />
            </label>
          </div>
        </el-form-item>

        <!-- 病例选择 -->
        <el-form-item label="病例文件" class="form-item">
          <div class="literature-selector" v-if="uploadType === '02'">
            <div class="selector-info" v-if="selectedLiteratureName">
              <i class="el-icon-file-text"></i>
              <span class="file-name">{{ selectedLiteratureName }}</span>
            </div>
            <el-button
                type="primary"
                icon="el-icon-search"
                @click="openLiteraturePopup"
                class="search-btn"
            >
              {{ selectedLiteratureName ? '重新选择' : '搜索病例' }}
            </el-button>
          </div>
        </el-form-item>

        <!-- 手动上传病例 -->
        <el-form-item label="上传病例" class="form-item" v-if="uploadType === '01'">
          <div class="upload-wrapper">
            <UploadOss
                v-model="uploadFileUrl"
                placeholder="点击或拖拽上传"
                accept=".pdf,.docx,.doc"
                upload-url="/article/oss/upload/literature?type=case"
                target-server="http://localhost:8079"
                @file-change="onFileChange"
            />
          </div>
          <!-- 显示上传的文件名 -->
          <div v-if="uploadFileUrl" class="uploaded-file-info">
            <i class="el-icon-file-text"></i>
            <span>{{ uploadedFileName || '已上传文件' }}</span>
          </div>
        </el-form-item>
      </div>

      <!-- 字数设置 -->
      <div class="form-section">
        <div class="section-title">
          <i class="el-icon-font-size"></i>
          <span>字数设置</span>
        </div>
        <el-form-item label="目标字数" class="form-item">
          <div class="word-select-wrapper">
            <el-select
                v-model="aiWords"
                placeholder="请选择字数"
                class="word-select"
            >
              <el-option
                  v-for="(item, index) in currentWordColumns"
                  :key="index"
                  :label="item + ' 字'"
                  :value="item"
              />
            </el-select>
            <div class="word-hint">
              <i class="el-icon-info"></i>
              <span>建议选择 {{ documentType === '01' ? '800-1500' : '1000-2000' }} 字</span>
            </div>
          </div>
        </el-form-item>
      </div>

      <!-- 生成按钮 -->
      <div class="btn-section">
        <el-button
            type="primary"
            size="large"
            :loading="btnLoading"
            @click="handleGenerate"
            class="generate-btn"
        >
          <i class="el-icon-magic"></i>
          开始生成
        </el-button>
      </div>

      <!-- 备注信息 -->
      <div class="tips-section">
        <div class="tips-card">
          <i class="el-icon-warning-outline"></i>
          <p>本平台医学助手生成的所有内容，仅供用户创作参考，不得直接用于商业发布、学术发表等正式场景。</p>
        </div>
      </div>
    </el-form>

    <!-- 文献搜索弹窗组件 -->
    <LiteratureSearchPopup
        :show="showLiteraturePopup"
        :type="searchPopupType"
        @update-show="val => showLiteraturePopup = val"
        @select="onSelectLiterature"
    />
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { generateAI, getGenerateAI, getKeywords, getAIConfig } from '@/api/aiassistant'
import LiteratureSearchPopup from '@/components/LiteratureSearchPopup.vue'
import UploadOss from '@/components/UploadOss.vue'

export default {
  name: 'GenerateModal',
  components: {
    LiteratureSearchPopup,
    UploadOss
  },
  data() {
      return {
        btnLoading: false,
        ailoading: false,
        pollTimer: null,
        pollCount: 0,
        MAX_POLL_COUNT: 600,
        uploadFileUrl: null,
        showLiteraturePopup: false,
        selectedLiteratureName: '',
        selectedLiteratureUrl: '',
        uploadType: '02',
        uploadedFileName: '', // 保存上传的文件名
        aiConfig: {
          science: true,
          literature: true,
          caseAnalysis: true
        },

        documentType: '01',
        documentName: '',
        aiKeyword: '',
        inputType: '01',
        aiWords: '',
        keywordsList: [],
        columns: ['基础总结与梳理', '核心结论解读', '临床应用价值'],
        wordConfig: {
          '01': ['800', '1000', '1500', '2000'],
          '02': ['1000', '1500', '2000', '2500', '3000'],
          '03': ['1000', '1500', '2000', '2500', '3000']
        },

        docTypeOptions: [
          { value: '01', label: '科普征文', desc: '基于关键词生成科普文章', icon: 'el-icon-edit' },
          { value: '02', label: '文献解读', desc: '解读上传的医学文献', icon: 'el-icon-file-search' },
          { value: '03', label: '案例解读', desc: '分析临床病例生成报告', icon: 'el-icon-user' }
        ],

        uploadTypeOptions: [
          { value: '01', label: '手动上传', icon: 'el-icon-upload' },
          { value: '02', label: '文献库查询', icon: 'el-icon-search' }
        ],

        inputTypeOptions: [
          { value: '01', label: '选择方向', icon: 'el-icon-list' },
          { value: '02', label: '手动输入', icon: 'el-icon-keyboard' }
        ]
      }
    },
  computed: {
    currentWordColumns() {
      return this.wordConfig[this.documentType] || []
    },
    searchPopupType() {
      // 根据文档类型返回对应的搜索类型
      // documentType: 02=文献解读, 03=案例解读
      // search type: literature=文献, case=病例
      return this.documentType === '03' ? 'case' : 'literature'
    },
    filteredDocTypeOptions() {
      // 根据AI配置过滤文档类型选项
      return this.docTypeOptions.filter(item => {
        switch (item.value) {
          case '01':
            return this.aiConfig.science !== false
          case '02':
            return this.aiConfig.literature !== false
          case '03':
            return this.aiConfig.caseAnalysis !== false
          default:
            return true
        }
      })
    }
  },
  watch: {
    documentType: {
      handler(newVal) {
        const list = this.wordConfig[newVal]
        this.aiWords = list?.[0] || ''
        this.aiKeyword = ''
        this.uploadType = '02'
        this.uploadFileUrl = null
        this.selectedLiteratureName = ''
        this.selectedLiteratureUrl = ''
      },
      immediate: true
    },
    uploadType() {
      this.uploadFileUrl = null
      this.selectedLiteratureName = ''
      this.selectedLiteratureUrl = ''
    }
  },
  created() {
    const headToken = localStorage.getItem('headToken');
    if (headToken) {
      this.getKeywords()
    }
    this.loadAIConfig()
  },
  beforeDestroy() {
    this.resetAILoading()
  },
  methods: {
    async getKeywords() {
      try {
        const res = await getKeywords()
        if (res.code !== 200) {
          this.$message.error(res.msg || '查询关键词失败');
          this.keywordsList = []
          return
        }
        this.keywordsList = res.data
      } catch (err) {
        console.error('关键词加载失败:', err)
        this.keywordsList = []
      }
    },

    async loadAIConfig() {
      const projectId = localStorage.getItem('projectId')
      if (!projectId) {
        return
      }
      try {
        const res = await getAIConfig(projectId)
        if (res.code === 200 && res.data) {
          this.aiConfig = {
            science: res.data.science !== false,
            literature: res.data.literature !== false,
            caseAnalysis: res.data.caseAnalysis !== false
          }
          // 如果当前选中的文档类型已被禁用，切换到第一个可用的类型
          const enabledTypes = this.filteredDocTypeOptions.map(item => item.value)
          if (!enabledTypes.includes(this.documentType)) {
            this.documentType = enabledTypes[0] || '01'
          }
        }
      } catch (err) {
        console.error('加载AI配置失败:', err)
      }
    },

    isDocTypeEnabled(docType) {
      switch (docType) {
        case '01':
          return this.aiConfig.science !== false
        case '02':
          return this.aiConfig.literature !== false
        case '03':
          return this.aiConfig.caseAnalysis !== false
        default:
          return true
      }
    },

    openLiteraturePopup() {
      this.showLiteraturePopup = true
    },

    onSelectLiterature(row) {
      this.selectedLiteratureName = row.liteName
      this.selectedLiteratureUrl = row.filePath
    },

    onFileChange(fileInfo) {
      // 保存上传的文件名
      this.uploadedFileName = fileInfo.name
    },

    radioChange() {
      this.aiKeyword = ''
      this.uploadFileUrl = ''
      this.selectedLiteratureName = ''
      this.selectedLiteratureUrl = ''
    },

    async handleGenerate() {
      this.resetAILoading()

      // 检查当前文档类型是否已启用
      if (!this.isDocTypeEnabled(this.documentType)) {
        const typeName = this.docTypeOptions.find(item => item.value === this.documentType)?.label
        return Message.error(`${typeName}功能已被管理员禁用，请联系管理员`)
      }

      const fileUrl = this.uploadType === '02' ? this.selectedLiteratureUrl : this.uploadFileUrl

      if (this.documentType === '01' && !this.aiKeyword?.trim()) {
        return Message.error('请填写文章关键词')
      }
      if (this.documentType === '02' && !fileUrl?.trim()) {
        return Message.error('请选择/上传文献')
      }
      if (this.documentType === '03' && !fileUrl?.trim()) {
        return Message.error('请选择/上传病例')
      }
      if (!this.aiWords) {
        return Message.error('请选择生成字数')
      }

      try {
        this.btnLoading = true
        this.ailoading = true

        const res = await generateAI({
          filePath: fileUrl,
          keywords: this.aiKeyword,
          documentType: this.documentType,
          inputType: this.inputType,
          aiWords: this.aiWords
        })

        if (res.code !== 200 || !res.data) {
          throw new Error(res.msg || '提交生成任务失败')
        }

        this.$message.success('已提交任务，正在为你生成，预计 1 分钟左右完成，请稍候～\n');
        this.startPollGenerateResult(res.data.taskId)

        this.$emit('close')


      } catch (e) {
        console.error(e)
        this.$message.error(e.message || 'AI生成失败');
        this.resetAILoading()
      } finally {
        this.btnLoading = false
      }
    },

    startPollGenerateResult(taskId) {
      if (this.pollTimer) return
      this.pollCount = 0
      this.pollTimer = setInterval(async () => {
        this.pollCount++
        if (this.pollCount >= this.MAX_POLL_COUNT) {
          this.$message.error('生成超时，请稍后重试');
          this.resetAILoading()
          return
        }
        try {
          const res = await getGenerateAI({ taskId })
          if (res.code === 99) return
          this.resetAILoading()
          if (res.code === 200 && res.data) {
            this.$message.success('文档生成完成');
            const doc = {
              id: Date.now(),
              genId: res.data.genId || taskId,
              keywords: res.data.keywords || this.aiKeyword,
              title: res.data.title || this.aiKeyword,
              genType: res.data.genType || this.documentType,
              genStatus: '2',
              content: res.data.content || '',
              resFile: res.data.resFile,
              filePath: res.data.resFile || this.uploadFileUrl,
              createTime: new Date().toLocaleString()
            }

            this.$emit('genSuccess', doc)
            this.$emit('close')
          } else {
            this.$message.error(res.msg || '生成失败');
          }
        } catch (err) {
          this.$message.error('查询生成状态失败');
          this.resetAILoading()
        }
      }, 3000)
    },

    resetAILoading() {
      this.ailoading = false
      this.pollCount = 0
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.generate-modal {
  padding: 24px;
  background: #f5f7fa;
  min-height: 400px;
}

.generate-form {
  .form-section {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 16px;
    border: 1px solid #e8eaed;
  }

  .section-title {
    display: flex;
    align-items: center;
    color: #333;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;

    i {
      margin-right: 8px;
      color: #1890ff;
    }
  }

  .form-item {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }

    :deep(.el-form-item__label) {
      color: #666;
      font-size: 13px;
      font-weight: 500;
    }
  }

  .radio-group-wrapper {
    display: flex;
    gap: 16px;
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .radio-card {
    flex: 0 0 calc(33.33% - 12px);
    min-width: 150px;
    max-width: 180px;
    padding: 16px 12px;
    border: 1px solid #e8eaed;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    background: #fff;
    text-align: center;

    &:hover {
      border-color: #1890ff;
      background: #f0f7ff;
    }

    &.active {
      border-color: #1890ff;
      background: #e6f7ff;

      .radio-icon {
        background: #1890ff;

        i {
          color: #fff;
        }
      }
    }

    &.small {
      flex: 0 0 calc(50% - 8px);
      min-width: 120px;
      max-width: 140px;
      padding: 12px 10px;
      flex-direction: row;
    }

    .radio-icon {
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      i {
        color: #4a90d9;
        font-size: 19px;
        font-weight: bold;
      }

      .small & {
        width: 28px;
        height: 28px;

        i {
          font-size: 14px;
        }
      }
    }

    .radio-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .radio-label {
      font-weight: 600;
      color: #333;
      font-size: 14px;
    }

    .radio-desc {
      font-size: 12px;
      color: #999;
      line-height: 1.4;
    }

    .radio-hidden {
      display: none;
    }
  }

  .custom-select {
    width: 100%;
    max-width: 260px;

    :deep(.el-select__wrapper) {
      border-radius: 6px;
    }
  }

  .custom-input {
    width: 100%;
    max-width: 260px;

    :deep(.el-input__wrapper) {
      border-radius: 6px;
    }
  }

  .literature-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    .selector-info {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 10px;
      background: #f5f7fa;
      border-radius: 4px;

      i {
        color: #1890ff;
        font-size: 12px;
      }

      .file-name {
        font-size: 12px;
        color: #333;
        max-width: 150px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .search-btn {
      border-radius: 4px;
      padding: 6px 14px;
      font-size: 12px;
    }
  }

  .word-select-wrapper {
    display: flex;
    align-items: center;
    gap: 10px;

    .word-select {
      width: 120px;

      :deep(.el-select__wrapper) {
        border-radius: 4px;
      }
    }

    .word-hint {
      font-size: 12px;
      color: #999;
    }
  }

  .btn-section {
    text-align: center;
    padding: 12px 0;

    .generate-btn {
      width: 160px;
      height: 38px;
      font-size: 13px;
      border-radius: 6px;
      background: #1890ff;
      border: none;
    }
  }

  .tips-section {
    margin-top: 8px;

    .tips-card {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      padding: 10px 12px;
      background: #fffbe6;
      border: 1px solid #ffe58f;
      border-radius: 4px;

      i {
        color: #faad14;
        font-size: 12px;
        margin-top: 1px;
      }

      p {
        margin: 0;
        font-size: 12px;
        color: #d48806;
      }
    }
  }
}
</style>
